import React from "react";
import img1 from "../assets/images/1.png";
import img2 from "../assets/images/5.png";
import img3 from "../assets/images/2.png";
import img4 from "../assets/images/4.png";
import img5 from "../assets/images/3.png";
import img6 from "../assets/images/6.png";
import img7 from "../assets/images/solidproof.png";

const Card = ({ img, icon, id }) => (
  <div className="w-[100%] sx:w-[200px] sm:w-[200px] h-[90px] sm:h-[110px] rounded-[15px] border border-red-800 p-4 lg:m-3 flex gap-1 justify-center items-center text-center">
    {/* {icon}
    <h2 className="text-lg text-white font-semibold mt-2">{title}</h2> */}
    <img
      style={{ color: "white", width: `${id === 5 ? "70%" : "100%"}` }}
      src={img}
      alt=""
    />
  </div>
);
const Partners = () => {
  const cards = [
    { img: img1, icon: "📦" },
    { img: img2, icon: "🛒" },
    { img: img3, icon: "💳" },
    { img: img4, icon: "📦" },
    { img: img5, icon: "🛒" },
    { img: img6, icon: "💳" },
    { img: img7, icon: "💳" },
  ];
  return (
    <>
      <div className="flex items-center justify-center text-white mt-[70px] lg:mt-[150px] partners_main_div ">
        <div className="red-1"></div>
        <div className="red-2"></div>
        <div className="text-center">
          <h1 className=" font-bold text-[35px] sm:text-[45px] md:text-[60px] mb-[25px]">
            OUR PARTNERS
          </h1>

          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-5 gap-4 p-4">
            {cards.map((card, index) => (
              <a
                key={index}
                href={
                  index === 3
                    ? "https://www.dexview.com/"
                    : index === 4
                    ? "http://www.pinksale.finance/"
                    : "#"
                } // Check if it's the 4th card
                className="card-link"
                target="_"
              >
                <Card key={index} img={card.img} icon={card.icon} id={index} />
              </a>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Partners;
